import {
  AppShell,
  Burger,
  Group,
  Header,
  MediaQuery,
  Navbar,
  useMantineTheme,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import SideBar from "../../components/adminSidebar";
import { AdminHeader } from "../../components/Headers/AdminHeader/AdminHeader";
import LoggedInUserProfile from "../../components/loggedInUserProfile";
import { allowUserLogin } from "../../Helpers";
export default function AdminHome() {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const [loadComponent, setLoadComponent] = useState(false);

  useEffect(() => {
    setLoadComponent(allowUserLogin("Admin"));
  }, []);

  return (
    loadComponent && (
      <AppShell
        styles={{
          main: {
            background:
              theme.colorScheme === "dark"
                ? theme.colors.dark[8]
                : theme.colors.gray[0],
          },
        }}
        navbarOffsetBreakpoint="sm"
        asideOffsetBreakpoint="sm"
        navbar={
          <Navbar
            bg={"#000"}
            p="md"
            hiddenBreakpoint="md"
            hidden={!opened}
            width={{
              base: !opened ? 0 : 325,
              md: 325,
              lg: 325,
            }}
          >
            <SideBar />
          </Navbar>
        }
        // footer={
        //   <AppshellFooter height={185}>
        //     <Footer />
        //   </AppshellFooter>
        // }
        header={
          <Header height={{ base: 70, md: 70 }} p="md" bg={"#000"}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                color: "black",
              }}
            >
              <MediaQuery largerThan="md" styles={{ display: "none" }}>
                <Group position="apart" noWrap style={{ width: "100%" }}>
                  <Burger
                    opened={opened}
                    onClick={() => setOpened((o) => !o)}
                    size="sm"
                    color={theme.colors.gray[6]}
                    mr="xl"
                  />
                  <AdminHeader />
                  <LoggedInUserProfile />
                </Group>
              </MediaQuery>
              <MediaQuery smallerThan="md" styles={{ display: "none" }}>
                <Group position="apart" noWrap style={{ width: "100%" }}>
                  <AdminHeader />
                  <LoggedInUserProfile />
                </Group>
              </MediaQuery>
            </div>
          </Header>
        }
      >
        <Outlet />
      </AppShell>
    )
  );
}
